import {hideLoader, showLoader} from '../redux/slice/loaderSlice.ts';
import {AppDispatch} from '../store';

interface LogoutResponse {
    logoutUrl: string;
}

export const logout = (dispatch: AppDispatch) => {
    dispatch(showLoader());

    return fetch(window.environment.backend + 'logout', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include'
    }).then((response) => {
        if (!response.ok) {
            dispatch(hideLoader());
            throw response;
        }

        return response.json() as Promise<LogoutResponse>;
    }).then((data) => {
        dispatch(hideLoader());
        if (data.logoutUrl) {
            window.location.href = data.logoutUrl;
        }
    }).catch(error => {
        dispatch(hideLoader());
        console.error(error);
    });
};
